import type { PricingDetails } from '~/interfaces/subscriptions';

export const fetchPricingDetails = async (): Promise<PricingDetails | null> => {
  const clientSearchParams = new URLSearchParams(window.location.search);
  const premiumOfferId = clientSearchParams.get('offer_id');
  const email = clientSearchParams.get('email');

  const loaderUrlSearchParams = new URLSearchParams();
  if (premiumOfferId) {
    loaderUrlSearchParams.append('offer_id', premiumOfferId);
  }
  if (email) {
    loaderUrlSearchParams.append('email', email);
  }

  const searchParamsString = loaderUrlSearchParams.size > 0 ? `?${loaderUrlSearchParams.toString()}` : '';
  const response = await fetch(`/pricing_details${searchParamsString}`, {
    method: 'GET',
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });

  if (response.ok) {
    return response.json();
  }

  return null;
};
